module.exports = __webpack_public_path__ + "static/media/ura_vinheta.d7fb4c83.mp4";